import { render, staticRenderFns } from "./ExpressSendTest.vue?vue&type=template&id=61c9f415&scoped=true"
import script from "./ExpressSendTest.vue?vue&type=script&lang=js"
export * from "./ExpressSendTest.vue?vue&type=script&lang=js"
import style0 from "./ExpressSendTest.vue?vue&type=style&index=0&id=61c9f415&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9f415",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
